import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'All Forms',
	url: '/all_forms',
	icon: 'archive',
}];

export default class All_Waivers extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;
		// console.log(';LAKSJDF;LAKJSDF')

		return (
			<div className="container-fluid">

				<Collections.AllWaivers
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

